import { SearchResult } from "../types/search.types";

interface Field {
  [key: string]: HTMLInputElement;
}

const SELECTOR_CLOSE_BUTTON = "[data-item='close-button']";

const FIELDS_TO_FILL: { [key: string]: string } = {
  pickupLocationName: "pickup",
  dropOffLocationName: "dropoff",
  direction: "direction",
  equipmentType: "equipmenttype",
};

export class FormService {
  public el: HTMLDivElement;
  public closeBtn: HTMLDivElement | null;
  public fields!: Field;

  constructor(el: HTMLDivElement) {
    this.el = el;
    this.closeBtn = this.el.querySelector(SELECTOR_CLOSE_BUTTON);

    this.init();
  }

  private init() {
    this.fields = this.saveFieldElements();

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => {
        this.close();
      });

      this.el.addEventListener("click", (event: MouseEvent) =>
        this.closeClickOutside(event)
      );
    }
  }

  private saveFieldElements() {
    const fields: Field = {};

    Object.keys(FIELDS_TO_FILL).forEach((key) => {
      const fieldId = FIELDS_TO_FILL[key];
      const field = this.el.querySelector(
        `input[type="hidden"]#${fieldId}`
      ) as HTMLInputElement;

      if (field) {
        fields[key] = field;
      }
    });

    return fields;
  }

  public fillFields(data: Partial<SearchResult>) {
    Object.keys(this.fields).forEach((key) => {
      const fieldValue = data[key];
      const field = this.fields[key];

      if (field && fieldValue) {
        field.value = fieldValue;
      }
    });
  }

  public show(data?: Partial<SearchResult>) {
    if (data) {
      this.fields = this.saveFieldElements();
      this.fillFields(data);
    }

    this.el.dataset.open = "true";
  }

  public close() {
    this.el.dataset.open = "false";
    this.clearData();
  }

  public closeClickOutside(event: MouseEvent) {
    if (event.target === this.el) {
      this.close();
    }
  }

  public clearData() {
    Object.keys(this.fields).forEach((key) => {
      const fieldElement = this.fields[key];
      fieldElement.value = "";
    });

    this.fields = {};
  }
}
